import {
	ProductComparisonResult,
	ProductItem,
	ProductPayload,
} from '../types/product.types';

export const isItemUpdated = (
	payloadItem: ProductPayload,
	currentItem: ProductItem
): boolean => {
	const comparison = compareFields(payloadItem, currentItem);
	return comparison.resultado;
};

export const compareFields = (
	payloadItem: ProductPayload,
	currentItem: ProductItem
): ProductComparisonResult => {
	const nomeMatch =
		String(currentItem.nome_produto) === String(payloadItem.nome_produto);

	// Se o campo não está no payload, não altera (mantém o valor atual)
	const custoMatch = payloadItem.hasOwnProperty('custo_produto')
		? String(currentItem.custo) === String(payloadItem.custo_produto)
		: true;

	const rateioMatch = payloadItem.hasOwnProperty('participa_rateio')
		? currentItem.participa_rateio ===
		  (String(payloadItem.participa_rateio).trim().toLowerCase() === 'sim')
		: true;

	const modeloMatch = payloadItem.hasOwnProperty('nome_modelo')
		? String(currentItem.nome_modelo_produto) ===
		  String(payloadItem.nome_modelo)
		: true;

	const statusMatch = payloadItem.hasOwnProperty('status')
		? currentItem.status ===
		  (String(payloadItem.status).trim().toLowerCase() === 'ativo')
		: true;

	const familiaMatch = payloadItem.hasOwnProperty('nome_familia')
		? String(currentItem.nome_familia) === String(payloadItem.nome_familia)
		: true;

	const subFamiliaMatch = payloadItem.hasOwnProperty('nome_sub_familia')
		? String(currentItem.nome_sub_familia) ===
		  String(payloadItem.nome_sub_familia || null)
		: true;

	const resultado =
		custoMatch &&
		nomeMatch &&
		rateioMatch &&
		modeloMatch &&
		statusMatch &&
		familiaMatch &&
		subFamiliaMatch;

	return {
		custoMatch,
		nomeMatch,
		rateioMatch,
		modeloMatch,
		statusMatch,
		familiaMatch,
		subFamiliaMatch,
		resultado,
	};
};

export const hasPayloadDataChanged = (
	payload: { arquivo: ProductPayload[] },
	currentData: ProductItem[]
): boolean => {
	if (!payload?.arquivo || !currentData) {
		return false;
	}

	for (const payloadItem of payload.arquivo) {
		const currentItem = currentData.find(
			(item: ProductItem) =>
				item.codigo_produto === payloadItem.codigo_produto
		);

		if (!currentItem) {
			return false;
		}

		const isUpdated = isItemUpdated(payloadItem, currentItem);

		if (!isUpdated) {
			return false;
		}
	}

	return true;
};

export const hasDataChanged = (
	previous: ProductItem[],
	current: ProductItem[]
): boolean => {
	if (!previous || !current) return true;

	const previousMap = new Map(
		previous.map((item: ProductItem) => [item.id, item])
	);
	const currentMap = new Map(
		current.map((item: ProductItem) => [item.id, item])
	);

	for (const [id, currentItem] of Array.from(currentMap)) {
		const previousItem = previousMap.get(id);
		if (!previousItem) return true;

		if (
			currentItem.custo !== previousItem.custo ||
			currentItem.nome_produto !== previousItem.nome_produto ||
			currentItem.participa_rateio !== previousItem.participa_rateio ||
			currentItem.nome_familia !== previousItem.nome_familia ||
			currentItem.nome_sub_familia !== previousItem.nome_sub_familia ||
			currentItem.nome_modelo_produto !== previousItem.nome_modelo_produto
		) {
			return true;
		}
	}

	return false;
};
